import React from 'react';
import CodeSparkThemedTypography from '../../../../components/elements/CodeSparkThemedTypography';
import CtaButton from '../../../../components/elements/CtaButton';
import CtaButtonContainer from '../../../../components/elements/CtaButton/CtaButtonContainer';
import {
  ColumnCenter,
  SectionPaddingSideRedesign,
  SectionPaddingVertical,
} from '../../../../components/global/Layout';
import CodingSkillRow from './CodingSkillRow';
import { getActivateCodingSkillsVariantData } from './activateCodingSkillsData';

import styles from './ActivateCodingSkills.module.css';
import { useExperimentVariantData } from '../../../../experiments/hooks';
import { EXPERIMENT_PAGE_DESIGN_FLAGS } from '../../../../experiments/constants';

const CTA_ID = 'section_activate_coding_skills';

function ActivateCodingSkills({ ctaLabel, onCtaClick }) {
  const handleCtaClick = e => onCtaClick(e, CTA_ID);
  const { header, codingSkills } = useExperimentVariantData(
    EXPERIMENT_PAGE_DESIGN_FLAGS,
    getActivateCodingSkillsVariantData
  );

  return (
    <SectionPaddingSideRedesign className={styles.activateCodingSkillsSection}>
      <SectionPaddingVertical>
        <ColumnCenter>
          <CodeSparkThemedTypography variant="h2" align="center">
            {header}
          </CodeSparkThemedTypography>

          <div className={styles.activateCodingSkillsContent}>
            {codingSkills.map((item, i) => {
              const isEven = i % 2 === 0;
              return (
                <CodingSkillRow key={`activate_coding_skills_${i}`} reverse={!isEven} {...item} />
              );
            })}
          </div>

          <CtaButtonContainer className={styles.activateCodingSkillsCtaContainer} fullWidthMobile>
            <CtaButton type="primary2" onClick={handleCtaClick} fullWidthMobile>
              {ctaLabel}
            </CtaButton>
          </CtaButtonContainer>
        </ColumnCenter>
      </SectionPaddingVertical>
    </SectionPaddingSideRedesign>
  );
}

export default ActivateCodingSkills;



// WEBPACK FOOTER //
// ./src/containers/Home/sections/ActivateCodingSkills/index.js